import {CardEnum, GameEventHistory, PlayerColor} from '@colonist/game-states'
import {VictoryPointDataController, VictoryPointTypes} from '@colonist/game-base-types'
import {ReplayHighlightData} from '@colonist/ui-game'

export function getHighlightsFromEventHistory(eventHistory: GameEventHistory): ReplayHighlightData[] {
    let highlights: ReplayHighlightData[] = []
    highlights = highlights
        .concat(getMonopolyHighlights(eventHistory))
        .concat(getLongestRoadLargestArmyHighlights(eventHistory))

    return highlights
}

function getMonopolyHighlights(eventHistory: GameEventHistory): ReplayHighlightData[] {
    const highlights: ReplayHighlightData[] = []

    for(let actionIndex = 0; actionIndex < eventHistory.events.length; actionIndex++) {
        const event = eventHistory.events[actionIndex]
        for(const key in event.stateChange.mechanicDevelopmentCardsState?.players) {
            const playerColor = Number(key) as PlayerColor
            const devCardState = event.stateChange.mechanicDevelopmentCardsState?.players[playerColor]

            if(devCardState == undefined) continue
            if(devCardState.developmentCardsUsed == undefined) continue
            if(devCardState.developmentCardsUsed[devCardState.developmentCardsUsed.length - 1] != CardEnum.Monopoly) continue

            highlights.push({actionIndex: actionIndex, type: 'monopolyPlayed'})
        }
    }

    return highlights
}

function getLongestRoadLargestArmyHighlights(eventHistory: GameEventHistory): ReplayHighlightData[] {
    const highlights: ReplayHighlightData[] = []

    let largestArmyGotForLastTimeAt: number | undefined
    let longestRoadGotForLastTimeAt: number | undefined

    for(let actionIndex = 0; actionIndex < eventHistory.events.length; actionIndex++) {
        const event = eventHistory.events[actionIndex]
        for(const key in event.stateChange.playerStates) {
            const playerColor = Number(key) as PlayerColor
            const playerState = event.stateChange.playerStates[playerColor]
            if(playerState?.victoryPointsState == undefined) continue

            for(const victoryPointTypeKey of Object.keys(playerState.victoryPointsState)) {
                const victoryPointType = Number(victoryPointTypeKey)
                const victoryPointStateValue = playerState.victoryPointsState[victoryPointType as any]
                if(Boolean(victoryPointStateValue) === false) {
                    continue
                }

                const victoryPointData = VictoryPointDataController.getVictoryPointByType(victoryPointType)
                if(victoryPointData?.victoryPointType == VictoryPointTypes.LargestArmy) {
                    largestArmyGotForLastTimeAt = actionIndex
                }
                if(victoryPointData?.victoryPointType == VictoryPointTypes.LongestRoad) {
                    longestRoadGotForLastTimeAt = actionIndex
                }
            }
        }
    }

    if(largestArmyGotForLastTimeAt != undefined) highlights.push({actionIndex: largestArmyGotForLastTimeAt, type: 'largestArmy'})
    if(longestRoadGotForLastTimeAt != undefined) highlights.push({actionIndex: longestRoadGotForLastTimeAt, type: 'longestRoad'})

    return highlights
}
